import { render, staticRenderFns } from "./aShopDetailServ.vue?vue&type=template&id=d6ec55e8&scoped=true"
import script from "./aShopDetailServ.vue?vue&type=script&lang=js"
export * from "./aShopDetailServ.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailServ.vue?vue&type=style&index=0&id=d6ec55e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ec55e8",
  null
  
)

export default component.exports